import { AxiosInstance } from 'axios';
import { axiosInstances } from './axios';

export const routes = {
  profile: {
    base: '/profile',
    login: '/profile/login',
    updateMobile: '/profile/update/mobile',
    getToken: '/profile/login/get-token',
    verificationDetail: '/profile/verification-detail',
    verifyOtpByTxnId: (txnId: string) => `/profile/otp/${txnId}/verify`,
    deleteAccount: '/profile/soft-delete'
  },
  verifier: {
    base: '/verifier'
  },
  verificationConfigs: {
    base: '/verification-configs',
    info: 'verification-configs/info'
  },
  //TODO: separate payments and verification api routes in transactions
  transactions: {
    base: '/transactions',
    process: '/transactions/process',
    processEvaluation: '/transactions/eval-info',
    evalConfigs: (providers: string) => `/eval-configs?evaluationServiceType=${providers}`,
    verifyIdentification: '/transactions/verify/identification',
    updateIdentification: '/transactions/update-identification',
    getById: (txnId: string, orgId: string) => `/transactions/info?orgId=${orgId}&txnId=${txnId}`,
    getVerificationById: (txnId: string, orgId: string, verification: string) =>
      `/transactions/${verification}/info?orgId=${orgId}&txnId=${txnId}`,
    getTxHistory: '/transactions/payment/history',
    getPaymentRegionList: '/transactions/payment/region',
    getPaidTxDetails: '/transactions/payment',
    getTxInfo: '/transactions/payment/price',
    getPaymentStatus: '/transactions/payment/poll',
    initPayment: '/transactions/payment/init',
    getPaymentMode: '/transactions/payment-option',
    markAsSkip: '/transactions/process/mark-as-skip',
    candidateTxn: '/transactions/candidate-transaction',
    purpose: {
      getPreStartQuestionList: '/purposes/user',
      submitAnswersToPreStartQuestionList: '/transactions/user-response'
    },
    nameChange: '/transactions/name-change-request',
    exportData: '/transactions/export-data'
  },
  ekycForms: {
    base: '/ekyc-forms',
    public: '/ekyc-forms/public'
  },
  files: {
    base: '/files',
    fromUrl: `/files/from-url`
  },
  verifications: {
    base: '/verifications',
    captcha: (verificationName: string) => `/verifications/pre-verify/${verificationName}`
  },
  credentials: {
    base: '/credentials',
    get: '/credentials',
    documents: (type: string) => `/credentials/documents/${type}`,
    receive: (verificationName: string) => `/credentials/receive/${verificationName}`
  },
  bgv: {
    base: '/bgv',
    insufficiency: '/bgv/insufficiency'
  },
  notifications: { base: '/notification' },
  tawkto: {
    base: '/profile/tawkto-hash',
    hash: '/profile/tawkto-hash'
  },
  pincode: {
    base: '/pincode'
  },
  fx: {
    base: '/detect-document-issues',
    document_issues: '/detect-document-issues'
  },
  account: {
    base: '/account',
    consent: '/profile/consent'
  },
  digilocker: {
    base: '/digilocker',
    preVerify: '/verifications/pre-verify/digilocker',
    verificationDetails: '/profile/verification-detail'
  }
};

export const customApiEndpoints: Record<
  string,
  (verificationName: string) => {
    url: string,
    axiosInstance: AxiosInstance | undefined,
    method?: string
  }
> = {
  BGV: () => ({ url: '/bgv', axiosInstance: axiosInstances.verificationV2 }),
  WEB_WALLET: (verificationName: string) => ({
    url: `/credentials/verify/${verificationName}`,
    axiosInstance: axiosInstances.webWallet
  }),
  AADHAAR_ONE: () => ({
    url: '/verifications/otp/aadhaar',
    axiosInstance: axiosInstances.verificationV1
  }),
  AADHAAR_TWO: () => ({ url: '/profile/aadhaar', axiosInstance: axiosInstances.issuer }),
  NO: () => ({
    url: '/profile/verification-detail',
    axiosInstance: axiosInstances.webWallet,
    method: 'PUT'
  }),
  INSTITUTE: () => ({ url: '/institutes', axiosInstance: axiosInstances.verificationV1 }),
  PROGRAM: () => ({ url: '/programs', axiosInstance: axiosInstances.verificationV1 }),
  BOARD: () => ({ url: '/boards', axiosInstance: axiosInstances.verificationV1 }),
  UNIVERSITY: () => ({
    url: 'v1/database/universities/web-wallet',
    axiosInstance: axiosInstances.evalApi
  })
};
